<template>
    <li class="relative w-full mr-6 ml-2 mb-1 p-2 rounded hover:bg-[#e4097e]">
    <svg class="fill-white" width="18px" height="18px" viewBox="0 0 45 45" @click="active = !active">
        <g>
            <path d="M43.462,35.997l-11.401-11.37c1.197-2.352,1.845-4.962,1.845-7.676c0-4.528-1.765-8.785-4.966-11.986
                C25.739,1.763,21.481,0,16.953,0C12.426,0,8.167,1.763,4.966,4.965C1.765,8.167,0,12.424,0,16.952
                c0,4.528,1.764,8.785,4.966,11.986c3.201,3.202,7.459,4.965,11.986,4.965c2.714,0,5.325-0.646,7.675-1.842l11.371,11.402
                c1.029,1.029,2.382,1.546,3.732,1.546c1.35,0,2.701-0.517,3.731-1.546C45.524,41.4,45.524,38.059,43.462,35.997z M9.444,24.459
                c-2.005-2.006-3.109-4.671-3.109-7.507s1.104-5.502,3.11-7.508c2.005-2.005,4.671-3.11,7.507-3.11s5.502,1.104,7.508,3.11
                c2.005,2.005,3.11,4.671,3.11,7.507s-1.105,5.502-3.11,7.508c-2.006,2.005-4.673,3.109-7.508,3.109
                C14.117,27.568,11.451,26.465,9.444,24.459z"/>
        </g>
    </svg>
    <div :class="[active ? 'block' : 'hidden']"
         class="absolute top-full right-0 origin-top-right bg-[#e4097e] rounded shadow-lg overflow-hidden mt-2 flex">
        <input @change="search" type="search" class="my-2 ml-2 p-2" placeholder="Search...">
        <span @click="search" class="flex items-center my-2 mr-2 py-2 px-4 text-white text-center whitespace-nowrap bg-[#052647]" id="basic-addon2">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" class="w-3 text-gray-400" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>
            </svg>
        </span>
    </div>
    </li>
</template>

<script>
export default {
    name: "Search",
    data () {
        return {
            active:false,
        }
    },
    methods:
        {
            search(event)
            {
                if(event !== "")
                {
                    window.location.href = "/search?q="+event.target.value;
                }
            }
        }
}
</script>

<style scoped>

</style>
